import styled from 'styled-components';
import colors from 'theme/colors';

/**
 * Peças visuais compartilhadas pelos três passos do cadastro de parceiro.
 *
 * Ficam aqui porque os passos antes repetiam o mesmo `FormContainer` e o mesmo
 * bloco de erro colado três vezes, com pequenas diferenças de espaçamento que
 * faziam a tela "pular" ao trocar de passo.
 */

export const StepShell = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const StepTitle = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.25;
    color: ${colors.nightDark};
    text-align: center;

    &:focus {
        outline: none;
    }
`;

export const StepSubtitle = styled.p`
    margin: 8px 0 0;
    font-size: 13px;
    line-height: 1.5;
    color: ${colors.night};
    text-align: center;
`;

export const FieldStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 24px;
`;

export const FieldRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 28px;
`;

/** Aviso de erro do passo inteiro (falha de rede, recusa do servidor). */
export const StepError = styled.p`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 18px 0 0;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid ${colors.danger}55;
    background: ${colors.danger}12;
    color: ${colors.dangerDark};
    font-size: 13px;
    line-height: 1.4;

    svg {
        flex-shrink: 0;
        margin-top: 1px;
    }
`;

/** Caixa neutra de contexto: o que vem a seguir, por que pedimos um dado. */
export const InfoBox = styled.div`
    margin-top: 20px;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid ${colors.secondaryPurple}2E;
    background: ${colors.secondaryPurple}0D;
`;

export const InfoTitle = styled.p`
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0 0 6px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    color: #6D14CC;
`;

export const InfoText = styled.p`
    margin: 0;
    font-size: 12px;
    line-height: 1.5;
    color: ${colors.night};
`;

export const InfoList = styled.ul`
    margin: 0;
    padding-left: 18px;
    font-size: 12px;
    line-height: 1.6;
    color: ${colors.night};
`;
